module.exports = ".leftText {\n  place-content: start !important; }\n\n.alineacionbtn {\n  display: block !important; }\n"